export default function ignoreErrors(call_function, ...args) {
    try {
        return call_function(...args);
        // eslint-disable-next-line no-empty
    } catch {
        return null;
    }
}
